import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { CustomTextField } from "../../../../partials/content/Forms";
import { onPreventEnterSubmitting } from "../../../../utils/utils";
import { DialogActions, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  getCustomers,
  saveCustomerContact,
} from "../../../../services/sales/customerService";
import Swal from "sweetalert2";
const AssignEmailForm = ({ onReloadInquiry, emailFrom, onCloseDialog }) => {
  const [customers, setCustomers] = useState();
  let contactData = {
    ID: 0,
    customerID: 0,
    name: "",
    position: "",
    phoneNumber: "",
    email: emailFrom,
  };

  useEffect(() => {
    async function getCustomerData() {
      const response = await getCustomers();
      setCustomers(response.data);
    }
    getCustomerData();
  }, []);

  const contactFormSchema = yup.object().shape({
    customerID: yup.number(),
    customerName: yup.string(),
    name: yup.string().required(),
    position: yup.string(),
    phoneNumber: yup.string().required(),
    email: yup.string().required(),
  });
  return (
    <Formik
      initialValues={contactData}
      validationSchema={contactFormSchema}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        values.customerID = parseFloat(values.customerID);
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to assign this Mail ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, assign it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveCustomerContact(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Assigned",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onReloadInquiry();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <Autocomplete
            disableClearable={true}
            inputValue={values.countryName}
            options={customers}
            getOptionLabel={(option) => option.customerName}
            onChange={(event, value) => {
              if (value.ID && value.ID !== null) {
                setFieldValue("customerID", value.ID);
                setFieldValue("customerName", value.customerName);
              }
            }}
            onInputChange={(event, value) => {
              setFieldValue("customerName", value);
            }}
            renderInput={(params) => (
              <TextField
                className="kt-width-full"
                {...params}
                label="Customer Name"
                variant="outlined"
                size="small"
              />
            )}
          />

          <CustomTextField
            label="Name"
            inputType="text"
            propertyName="name"
            onBlur={handleBlur}
            onChange={handleChange}
            values={values}
            touched={touched}
            errors={errors}
            size="small"
          />
          <CustomTextField
            label="Position"
            inputType="text"
            propertyName="position"
            onBlur={handleBlur}
            onChange={handleChange}
            values={values}
            touched={touched}
            errors={errors}
            size="small"
          />
          <CustomTextField
            label="Phone Number"
            inputType="text"
            propertyName="phoneNumber"
            onBlur={handleBlur}
            onChange={handleChange}
            values={values}
            touched={touched}
            errors={errors}
            size="small"
          />
          <CustomTextField
            label="Email"
            inputType="email"
            propertyName="email"
            onBlur={handleBlur}
            onChange={handleChange}
            values={values}
            touched={touched}
            errors={errors}
            size="small"
            endAdornment={{
              readOnly: true,
            }}
          />
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary btn-md btn-pill btn-bold"
              disabled={isSubmitting}
            >
              <i className="fas fa-save"></i>
              Save
            </button>
          </DialogActions>
        </form>
      )}
    </Formik>
  );
};

export default AssignEmailForm;
